import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter'
import { docco } from 'react-syntax-highlighter/dist/styles'

//icons
import LineChartIcon from 'grommet/components/icons/base/LineChart';
import OptimizeIcon from 'grommet/components/icons/base/Optimize';
import CalculatorIcon from 'grommet/components/icons/base/Calculator';

const Data = [
    {
        title: "Anomaly Analysis GPU",
        tag: "",
        icon: OptimizeIcon,
        description: "Anomaly Analysis",
    }, {
        title: "Linear Gradient Descent GPU",
        tag: "<prophesier-regressiongradesc-gpu /> <RegressionGraDescGPU />",
        icon: LineChartIcon,
        description: "Linear Regression using Gradiente Descent Algorithm. Calculations for training are done in the GPU",
    }, {
        title: "Descriptive Metrics GPU",
        tag: "<prophesier-descriptive-gpu /> <DescriptiveGPU />",
        icon: CalculatorIcon,
        description: "Descriptive statistics for a multidimensional array input. Calculates min, max, range, mean, variance. GPU used for processing",
    }
];

const SidebarDOC = (props) => {

const text = `/*** React ***/ 
import React from 'react'
import { DescriptiveGPU } from 'prophesier/dist/wrapper';

class DescriptiveGPU extends React.Component {
    render() {
        <DescriptiveGPU />
    }
}

/*** jQuery ***/

const chart = $("<prophesier-descriptive-gpu></prophesier-descriptive-gpu>")
$(document.body).append(chart)
`
    return (
        <div>
            <div>
                <br /><br /><div className="button-text-title">1 Download </div><br/>
                                 
                <br /><br />
                < SyntaxHighlighter language='javascript' style={docco}>
                    npm install prophesier --save
                </SyntaxHighlighter>
                <br /><br /><div className="button-text-title">2 Load </div><br/>
        
                <br /><br />
                <SyntaxHighlighter language='html' style={docco}> 
                    &lt;script src="&lt; PATH_TO_ &gt; node_modules/prophesier/dist/index-with-deps.min.js"&gt;&lt;/script&gt;
                </SyntaxHighlighter>
                <SyntaxHighlighter language='html' style={docco}> 
                    import "prophesier"
                </SyntaxHighlighter>
                <br /><br /><div className="button-text-title">3 Wrappers </div><br/>
                <div className="button-text">React wrapper located in <code>node_modules/prophesier/dist/wrapper</code> to import the elements (Only for React users). jQuery/native does not need any wrapper ;)</div> 
                <br /><br />
                <SyntaxHighlighter language='javascript' style={docco}> 
                    {text}
                </SyntaxHighlighter> */}
                <br /><br /><div className="button-text-title">4 Samples </div><br/>
            </div>
        </div>
    )
}


export default SidebarDOC


// WEBPACK FOOTER //
// ./src/samples/ContentDOC.js